import React from "react";
import { Icon } from "../icons";
import {
  avatarColor,
  fmtDate,
  initials,
  moveTypeLabel,
  ordinal,
} from "../lib/format";
import { openJobPage } from "../lib/jobLink";
import { highestAttempt } from "../lib/jobStatus";
import { isHourlyJob } from "../lib/hourly";
import { useMcOps } from "../lib/McOpsContext";
import { RevisionList } from "../components/Common";
import { JobActions } from "./JobActions";
import { buildTabs, JobTabBody } from "./jobTabs";

export const JobModal = () => {
  const { state, activeJob, activeTab, setActiveTab, closeModal, actions } =
    useMcOps();

  if (!activeJob) return null;
  const job = activeJob;
  const isLD = job.moveType === "ld";
  const tabs = buildTabs(isLD);
  // The Confirmation Call and Post Move count their own attempts; every other section shows the intro call's.
  const attempts =
    activeTab === "s3" ? job.confirmAttempts : activeTab === "s5" ? job.postMoveAttempts : job.introAttempts;
  const attemptCount = highestAttempt(attempts);

  return (
    <div
      className="modal-overlay open"
      onClick={(e) => {
        if (e.target === e.currentTarget) closeModal();
      }}
    >
      <div className="modal">
        <div className="modal-head">
          <div className="mh-left">
            <div
              className="mh-avatar"
              style={{ background: avatarColor(job.moveType) }}
            >
              {initials(job.clientName)}
            </div>
            <div>
              <h3>
                {job.clientName} — {job.zohoId}
                {isHourlyJob(job) ? "  ·  HOURLY JOB" : ""}
              </h3>
              <div className="meta">
                {moveTypeLabel(job.moveType)} · {job.moveFrom} → {job.moveTo} · Move
                date {fmtDate(job.moveDate)}
                {job.salesperson ? " · Booked by " + job.salesperson : ""}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {attemptCount > 0 ? (
              <span
                className="badge plain"
                style={{
                  background: "var(--warning-light)",
                  color: "var(--warning)",
                }}
              >
                {ordinal(attemptCount)} Attempt Called
              </span>
            ) : null}
            {job.zohoUrl ? (
              <button
                type="button"
                className="btn small"
                title="Open this lead in Zoho CRM"
                onClick={() => window.open(job.zohoUrl, "_blank", "noopener")}
              >
                <Icon name="external" />
                Open in Zoho
              </button>
            ) : null}
            <button
              type="button"
              className="btn small"
              onClick={() => openJobPage(job.id, activeTab)}
            >
              <Icon name="external" />
              Open in new tab
            </button>
            <button className="modal-close" onClick={closeModal}>
              <Icon name="x" />
            </button>
          </div>
        </div>

        {job.status === "confirmed-update" ? (
          <RevisionList
            job={job}
            className="revision-banner"
            onReviewed={(text) => actions.markRevisionReviewed(job.id, text)}
          />
        ) : null}

        <div className="modal-tabs">
          {tabs.map((t) => (
            <button
              className={`mtab-btn${t.id === activeTab ? " active" : ""}`}
              key={t.id}
              onClick={() => setActiveTab(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="modal-body">
          <JobTabBody
            tab={activeTab}
            job={job}
            isLD={isLD}
            escalations={state.escalations}
            actions={actions}
          />
        </div>

        <div className="modal-foot">
          <JobActions
            job={job}
            isLD={isLD}
            activeTab={activeTab}
            actions={actions}
          />
        </div>
      </div>
    </div>
  );
};
